export default __webpack_public_path__ + "static/media/mode-522.c68702d2.svg";